import { VehicleEntry } from '@carvana/helios-composites';
import { breakpoint } from '@carvana/helios-layout';
import { background, border, canvas } from '@carvana/helios-styles';
import { datadogRum } from '@datadog/browser-rum';
import styled from 'styled-components';

import { APP_BASE_PATH } from '../utilities/appBasePath';
import { buildNavigationUrl } from '../utilities/routes';

const wizardRoute = `${APP_BASE_PATH}/getoffer/vehicle`;

type SubmitPlateVin = { vin: string } | { plate: string; plateState: string };

const BlankPage = styled.div`
  background-color: ${canvas.default};
`;

const CardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  min-width: 327px;
  width: 100%;
  padding: 0;
  z-index: 10;

  ${breakpoint.sm`
    min-width: unset;
  `};

  ${breakpoint.md`
    margin: 0;
    padding: 0;
  `}
`;

const Card = styled.div`
  box-sizing: border-box;
  min-height: 274px;
  width: 516px;
  padding: 6px 16px;
  border: 1px solid ${border.weak};
  border-radius: 16px;
  background-color: ${background.default};

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${breakpoint.md`
    max-height: 286px;
  `}
`;

const VehicleEntryContainer = () => {
  const submitPlateVin = (info: SubmitPlateVin) => {
    const sendToWizard: { vin: string } | { licensePlate: string; plateState: string } =
      'vin' in info ? { vin: info.vin } : { licensePlate: info.plate, plateState: info.plateState };

    if ('vin' in info) {
      datadogRum.setGlobalContextProperty('vin', info.vin);
    }

    const redirectUrl = buildNavigationUrl(wizardRoute, sendToWizard);
    window.location.href = redirectUrl;
  };

  return (
    <BlankPage>
      <CardWrapper>
        <Card>
          <VehicleEntry submitPlateVin={submitPlateVin} submitText="Get My Offer" />
        </Card>
      </CardWrapper>
    </BlankPage>
  );
};

export default VehicleEntryContainer;
